import { theme, styled } from 'ui/theme';

import ButtonBase from './ButtonBase';

const ButtonGhost = styled(ButtonBase)`
  background: transparent;
  border-color: ${theme.colors.action.navigation.standard.static};
  color: ${theme.colors.action.navigation.standard.static};

  &:hover {
    background: ${theme.colors.action.navigation.standard.highlight};
    color: ${theme.colors.build.lightLight};
  }
`;

export default ButtonGhost;
